import { render, staticRenderFns } from "./superTableSectionUpdate.vue?vue&type=template&id=bac3ad56"
import script from "./superTableSectionUpdate.vue?vue&type=script&lang=js"
export * from "./superTableSectionUpdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports